import { api } from "../Configurations/axios";
import { BillingProductsModel } from "../Models/BillingProductsModel";

const GetBillingProducts = async (id: string) => {
    try {

        const result = await api.get(`/BillingProductsFinep/GetByregistrationDocumentsId/${id}`);
        const response = await result.data;

        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const PostBillingProducts = async (model: BillingProductsModel) => {
    try {

        const result = await api.post(`/BillingProductsFinep/Post`, model);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

export {
    GetBillingProducts,
    PostBillingProducts
}